
import { forkJoin as observableForkJoin, Observable, forkJoin } from 'rxjs';
import { Component, OnInit, ElementRef } from '@angular/core';
import { AddUserService } from "app/user/add-user/add-user.service";
import { UserResource } from "app/resources/user/user-resource";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { RoleResource } from "app/resources/role/role-resource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { NotificationsService } from "angular2-notifications";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from "app/services/utils.service";
import { EditUserService } from 'app/user/edit-user/edit-user.service';
@Component({
  selector: 'vbn-add-edit-appointment-officer',
  templateUrl: './add-edit-appointment-officer.component.html',
  styleUrls: ['./add-edit-appointment-officer.component.scss']
})
export class AddEditAppointmentOfficerComponent implements OnInit {


  addressParams: any;
  userResource: UserResource;
  roleListResource: RoleListResource;
  //adminProfileResource: AdminProfileResource;
  errorMessage: string;
  showSuccessAlert = false;
  private timer;
  saveErrors: boolean = false
  emailExist: boolean = false
  correctEmail: boolean = false;
  logoLang = '0';
  selected_language: string = "ro";
  userRoleId = localStorage.getItem("_roleId");
  selectedClient: string;
  userEmail: string;



  constructor(
    private translate: TranslateService,
    private addUserService: AddUserService,
    private _router: Router,
    private fb: FormBuilder,
    private _notificationService: NotificationsService,
    private utilsService: UtilsService,
    private element: ElementRef,
    private activatedRoute: ActivatedRoute,
    private editUserService: EditUserService,) {
    this.userResource = new UserResource();
    this.userResource.role = new RoleResource();
    this.roleListResource = new RoleListResource();
    //this.adminProfileResource = new AdminProfileResource();
  }

  addForm = this.fb.group({
    firstName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    // 3-100 de caractere pentru a interzice introducerea de spatiu
    lastName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    phone: ['', [Validators.nullValidator]],
    // companyName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
    function: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), this.utilsService.NoWhitespaceValidator()]],
    // role: ['', [Validators.required]],
  })


  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['json'] != null) {
        this.addressParams = JSON.parse(atob(params['json']));
        this.getUserProfile(this.addressParams.userEmail);
      }
    });
    this.selectedClient = (localStorage.getItem("_sc") === null) ? null : atob(localStorage.getItem("_sc")); // if we have a selected client in dashboard
    this.userEmail = this.utilsService.currentUserEmail;

    this.getUserRoles();
    // this.getAdminProfile();
  }

  getUserProfile(email: string) {
    this.editUserService.getUserProfile('/admin/user/getProfile?userName=' + email)
      .subscribe(
        response => {
          this.userResource = response;

          if (this.userResource.logoDe !== null) {
            this.logoLang = "1"; // multi logo ; each for each language
          }
        },
        error => this.errorMessage = <any>error);
  }

  getUserRoles() {
    this.addUserService.getUserRoles('/admin/role/getAll?clientUser=' + this.userEmail)
      .subscribe(
        response => {
          this.roleListResource = response;
        },
        error => this.errorMessage = <any>error);
  }

  onSubmit() {
    this.saveErrors = true

    if (!this.addForm.valid) {
      observableForkJoin(
        [this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })

      //this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
      return
    }

    let checkEmail = this.userResource.email.indexOf('@');
    if (this.userResource.email.includes('.', checkEmail)) {
      this.correctEmail = false;
    }
    else {
      this.correctEmail = true;
      return;
    }

    this.userResource.firstName = this.utilsService.WhiteSpacesRemover(this.userResource.firstName);
    this.userResource.lastName = this.utilsService.WhiteSpacesRemover(this.userResource.lastName);
    this.userResource.isOneLogo = (this.logoLang === '0') ? true : false;
    if (this.selectedClient) { // only if we are logged as an admin, an we selected a lient from dashboard, we send a parrent user
      this.userResource.parrentUser = new UserResource();
      this.userResource.parrentUser.email = this.selectedClient;
    }
    this.userResource.role = this.roleListResource.roles[0]; ///for now, for this view, we have only the Appointment Officer role
    this.userResource.companyName = "-";


    this.addUserService.addUser('/admin/user/createEdit', this.userResource)
      .subscribe(
        (response: UserResource) => {
          this.userResource = response;

          let errMsg = "";
          switch (this.userResource.errorCode) {
            case 1009:
            case 1042:
            case 1043:
              errMsg = 'The user was not added';
              break;
            case 1044:
              errMsg = 'You do not have rights to edit the user';
              break;
            case 1045:
              errMsg = 'The email can not be changed';
              break;
            case 1041:
              errMsg = 'User already in use';
              break;
          }

          if (errMsg !== "") {
            observableForkJoin(
              [this.translate.get('Error'),
              this.translate.get(errMsg)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            this.showSuccessAlert = true;
            observableForkJoin(
              [this.translate.get('Success'),
              this.translate.get('The user has been successfully added')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })

            this._router.navigate([`/appointments-officers-list`])
          }
        },
        error => {
          this.emailExist = true;
        });
  }
  back() {
    this._router.navigate([`/appointments-officers-list`])
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}

